/**
 * MoreVertIcon — auto-generated by scripts/generate-icons.ts.
 * Do NOT edit manually — re-run `yarn codegen:icons` to regenerate.
 */

// SVGProps is used by the SVGR-generated component below.
import type { SVGProps } from 'react'
import { makeIcon } from '../make-icon'

interface SVGRProps {
  title?: string
  titleId?: string
}
const MoreVertIconSvg = ({ title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    viewBox="0 0 24 24"
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path d="M12 7a2 2 0 1 1 0-4 2 2 0 0 1 0 4m-2 5a2 2 0 1 0 4 0 2 2 0 0 0-4 0m0 7a2 2 0 1 0 4 0 2 2 0 0 0-4 0" />
  </svg>
)

/** @see {@link https://design.reapit.com.au} Reapit DS icon */
export const MoreVertIcon = makeIcon('MoreVertIcon', MoreVertIconSvg)
